export default "/images/vendor/flag-icon-css/flags/4x3/iq.svg?7a8858e71522f3d9d56e3b62ba85443b";